import React from 'react'
import * as subhedStyles from '../../styles/project-modules/subhed.module.less'

function Subhed({ title, deck }) {
  return (
    <>
      <h3 className={`${subhedStyles.subhed} ${!deck ? subhedStyles.mb : ''}`}>
        {title}
      </h3>
      {deck && <p className={subhedStyles.dek}>{deck}</p>}
    </>
  )
}

export default Subhed
